import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import CallHistoryCard from 'components/CallRecording/CallHistoryCard';
import { usePermission } from '../../auth/usePermission';
import { CountrySelect, StateSelect, CitySelect } from 'components/GeographySelect';
import {
  Card,
  Grid,
  Divider,
  Modal,
  Box,
  TextField,
  CircularProgress,
  Chip,
  Snackbar,
  Alert,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Tooltip,
  Avatar,
  Typography,
} from "@mui/material";
import { Delete, FileCopy, Close, Edit, Save } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import CallButton from "components/Softphone/CallButton";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import InlineEditField from 'components/CustonEditableInlineField/CustomEditableInlineField';
import Activities from 'layouts/dashboard/components/Activities';
import AttachmentUploadModal from 'components/CustomModals/AttachmentUploadModal';
import Attachments from 'layouts/dashboard/components/Attachments';
import { formatDate } from 'utils/DateTimeConversion';
import { useTheme } from '@mui/material/styles';
import ActivityModal from 'components/CustomModals/CustomActivityModal';
import CustomFieldsSection from "components/CustomFields/CustomFieldsSection";
import DataLoadingSpinner from 'components/Spinners/DataLoadingSpinner';
import AddressAutocompleteInput from 'layouts/Travel/trips/stepForm/fields/AddressAutocompleteInput';
// FIX: this was previously importing from 'components/AddContactModal' (the
// small quick-add modal, wrong component/prop contract entirely). The clone
// flow needs the full form, which lives in NewContactModal.
import ContactFormModal from 'components/NewContactModal';

import colors from "assets/theme/base/colors";
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';


import { Email, PictureAsPdf } from '@mui/icons-material';
import EmailModal from 'components/EmailModal/index.js';
import EventIcon from '@mui/icons-material/Event';
import AttachmentIcon from '@mui/icons-material/Attachment';
import CreateIcon from '@mui/icons-material/Create';
import UnauthorizedAccess from 'components/StyledAccessDenied';
import { frontendLogger } from '../../utils/logger';
import { downloadPrivateObject } from 'utils/S3';
import EchoComposer from 'components/EchoComposer/EchoComposer';
import MDUserAvatar from 'components/MDUserAvatar';
import { commonIconButtonStyles } from 'assets/theme/components/iconButtonStyles';
import { validatePersonOrEntityName } from "utils/crmValidation";
import { RecordCallProvider } from "components/v2/RecordCallContext";
import RecordPageV2, { TabStack } from "components/v2/record/RecordPageV2";
import { HeroBadge } from "components/v2/record/RecordHero";
import { StatusBadge } from "layouts/crm/account360/RelatedList";
import ActivityTimeline from "layouts/crm/account360/ActivityTimeline";
import { relativeTime } from "layouts/crm/account360/format";
import { linkedValue } from "components/v2/ContactValue";
import { Briefcase, Building2, CalendarDays, CheckSquare, Clock, History, LayoutGrid, Mail, MapPin, Paperclip, Phone, UserRound } from "lucide-react";
import { UiDetailSection } from "components/v2/record/DetailSection";


// Add capitalizeFirstLetter function
const capitalizeFirstLetter = (str) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Shared with NewContactModal/index.js and AddContactModal/index.js so all
// three entry points agree on the exact pairing-requirement message text.
export const CONTACT_EMAIL_PHONE_REQUIRED = 'Either Email or Phone is required';


function ContactDetail() {

  const { id } = useParams();
  const { user, axiosInstance } = useAuth();
  const { isSupportUser } = usePermission('contacts');
  // UI v2 record layout (design-reference "Sales · Deal record").
  const isV2 = useTheme()?.pearlUi === 'v2';
  const navigate = useNavigate();
  const [contact, setContact] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [updatedFields, setUpdatedFields] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [activities, setActivities] = useState([]);
  const [isActivityModalOpen, setIsActivityModalOpen] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [isAttachmentModalOpen, setIsAttachmentModalOpen] = useState(false);
  const [isCloning, setIsCloning] = useState(false);
  const [isCloneModalOpen, setIsCloneModalOpen] = useState(false);
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const [newActivity, setNewActivity] = useState({
    contact_id: id,
    type: '',
    description: '',
    date: new Date().toISOString().split('T')[0],
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [agents, setAgents] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [customFields, setCustomFields] = useState([]);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [newEmail, setNewEmail] = useState({
    to: '',
    cc: '',
    bcc: '',
    subject: '',
    content: ''
  });
  const [isGeneratingEmail, setIsGeneratingEmail] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [showCc, setShowCc] = useState(false);
  const [showBcc, setShowBcc] = useState(false);
  const [emailContext, setEmailContext] = useState({});
  const [emailAttachments, setEmailAttachments] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [isActivitySaving, setIsActivitySaving] = useState(false);
  const [isDiscarding, setIsDiscarding] = useState(false);
  const [isEmailSending, setIsEmailSending] = useState(false);
  const [isDeletingContact, setIsDeletingContact] = useState(false);
  const customFieldsRef = useRef(null);
  const [sectionOrder, setSectionOrder] = useState([]);
  const [hiddenSections, setHiddenSections] = useState([]);
  const [loadingSections, setLoadingSections] = useState(true);

  // State for cached names
  const [nameCache, setNameCache] = useState({});
  
  // State for feed items
  const [feedItems, setFeedItems] = useState([]);
  const [isFeedLoading, setIsFeedLoading] = useState(false);
  
  // State for editing feed items
  const [editingFeedItem, setEditingFeedItem] = useState(null);
  const [editFeedContent, setEditFeedContent] = useState('');
  const [isEditingFeed, setIsEditingFeed] = useState(false);
  
  // State for echo modal
  const [isEchoModalOpen, setIsEchoModalOpen] = useState(false);
  const [newEchoContent, setNewEchoContent] = useState('');
  const [isCreatingEcho, setIsCreatingEcho] = useState(false);
  
  // State for delete confirmation
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const cloneAnimationKeyframes = `
  @keyframes cloneAnimation {
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  }
`;

  useEffect(() => {
    if (Object.keys(formErrors).length > 0) {
      console.log('Form errors updated:', formErrors);
    }
  }, [formErrors]);

  const [accounts, setAccounts] = useState([]);

  // Function to fetch lead name
  const fetchLeadName = async (leadId) => {
    if (nameCache[`lead_${leadId}`]) {
      return nameCache[`lead_${leadId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/leads/${leadId}`);
      const leadName = response.data.full_lead_name || `Lead #${leadId}`;
      setNameCache(prev => ({ ...prev, [`lead_${leadId}`]: leadName }));
      return leadName;
    } catch (error) {
      console.error('Error fetching lead name:', error);
      return `Lead #${leadId}`;
    }
  };

  // Function to fetch account name
  const fetchAccountName = async (accountId) => {
    if (nameCache[`account_${accountId}`]) {
      return nameCache[`account_${accountId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/accounts/${accountId}`);
      const accountName = response.data.name || `Account #${accountId}`;
      setNameCache(prev => ({ ...prev, [`account_${accountId}`]: accountName }));
      return accountName;
    } catch (error) {
      console.error('Error fetching account name:', error);
      return `Account #${accountId}`;
    }
  };

  // Function to fetch deal name
  const fetchDealName = async (dealId) => {
    if (nameCache[`deal_${dealId}`]) {
      return nameCache[`deal_${dealId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/deals/${dealId}`);
      const dealName = response.data.name || `Deal #${dealId}`;
      setNameCache(prev => ({ ...prev, [`deal_${dealId}`]: dealName }));
      return dealName;
    } catch (error) {
      console.error('Error fetching deal name:', error);
      return `Deal #${dealId}`;
    }
  };

  // Function to fetch contact name
  const fetchContactName = async (contactId) => {
    if (nameCache[`contact_${contactId}`]) {
      return nameCache[`contact_${contactId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/contacts/${contactId}`);
      const contactName = `${response.data.first_name || ''} ${response.data.last_name || ''}`.trim() || `Contact #${contactId}`;
      setNameCache(prev => ({ ...prev, [`contact_${contactId}`]: contactName }));
      return contactName;
    } catch (error) {
      console.error('Error fetching contact name:', error);
      return `Contact #${contactId}`;
    }
  };

  // Function to fetch entity name based on type
  const fetchEntityName = async (entityType, entityId) => {
    switch (entityType.toLowerCase()) {
      case 'lead':
        return await fetchLeadName(entityId);
      case 'account':
        return await fetchAccountName(entityId);
      case 'deal':
        return await fetchDealName(entityId);
      case 'contact':
        return await fetchContactName(entityId);
      case 'order':
        return await fetchOrderName(entityId);
      case 'invoice':
        return await fetchInvoiceName(entityId);
      case 'quote':
        return await fetchQuoteName(entityId);
      case 'product':
        return await fetchProductName(entityId);
      case 'case':
        return await fetchCaseName(entityId);
      default:
        return `${entityType} #${entityId}`;
    }
  };

  // Function to fetch user name
  const fetchUserName = async (userId) => {
    if (nameCache[`user_${userId}`]) {
      return nameCache[`user_${userId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/users/${userId}`);
      const userName = response.data.fullname || response.data.full_name || response.data.username;
      setNameCache(prev => ({ ...prev, [`user_${userId}`]: userName }));
      return userName;
    } catch (error) {
      console.error('Error fetching user name:', error);
      return `User ${userId}`;
    }
  };

  // Function to fetch order name
  const fetchOrderName = async (orderId) => {
    if (nameCache[`order_${orderId}`]) {
      return nameCache[`order_${orderId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/orders/${orderId}`);
      const orderName = response.data.order_number || `Order #${orderId}`;
      setNameCache(prev => ({ ...prev, [`order_${orderId}`]: orderName }));
      return orderName;
    } catch (error) {
      console.error('Error fetching order name:', error);
      return `Order #${orderId}`;
    }
  };

  // Function to fetch invoice name
  const fetchInvoiceName = async (invoiceId) => {
    if (nameCache[`invoice_${invoiceId}`]) {
      return nameCache[`invoice_${invoiceId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/invoices/${invoiceId}`);
      const invoiceName = `Invoice #${response.data.invoice_number || invoiceId}`;
      setNameCache(prev => ({ ...prev, [`invoice_${invoiceId}`]: invoiceName }));
      return invoiceName;
    } catch (error) {
      console.error('Error fetching invoice name:', error);
      return `Invoice #${invoiceId}`;
    }
  };

  // Function to fetch quote name
  const fetchQuoteName = async (quoteId) => {
    if (nameCache[`quote_${quoteId}`]) {
      return nameCache[`quote_${quoteId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/quotations/${quoteId}`);
      const quoteName = response.data.quote_name || `Quote #${quoteId}`;
      setNameCache(prev => ({ ...prev, [`quote_${quoteId}`]: quoteName }));
      return quoteName;
    } catch (error) {
      console.error('Error fetching quote name:', error);
      return `Quote #${quoteId}`;
    }
  };

  // Function to fetch product name
  const fetchProductName = async (productId) => {
    if (nameCache[`product_${productId}`]) {
      return nameCache[`product_${productId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/products/${productId}`);
      const productName = response.data.name || `Product #${productId}`;
      setNameCache(prev => ({ ...prev, [`product_${productId}`]: productName }));
      return productName;
    } catch (error) {
      console.error('Error fetching product name:', error);
      return `Product #${productId}`;
    }
  };

  // Function to fetch case name
  const fetchCaseName = async (caseId) => {
    if (nameCache[`case_${caseId}`]) {
      return nameCache[`case_${caseId}`];
    }
    
    try {
      const response = await axiosInstance.get(`/cases/${caseId}`);
      const caseName = response.data.case_number || `Case #${caseId}`;
      setNameCache(prev => ({ ...prev, [`case_${caseId}`]: caseName }));
      return caseName;
    } catch (error) {
      console.error('Error fetching case name:', error);
      return `Case #${caseId}`;
    }
  };

  const fetchAccounts = async () => {
    try {
      console.log('Fetching accounts from API...');
      const response = await axiosInstance.get('/accounts/?status=active');
      console.log('Raw account data:', response.data);

      const formattedAccounts = response.data.map(account => {
        console.log('Processing account:', account);
        return {
          value: account.id,
          label: account.name || `Account ${account.name}`,
          fullData: account
        };
      });

      console.log('Formatted accounts:', formattedAccounts);
      setAccounts(formattedAccounts);
    } catch (error) {
      console.error('Detailed account fetch error:', {
        message: error.message,
        response: error.response,
        request: error.request
      });
      setSnackbar({
        open: true,
        message: `Error fetching accounts: ${error.message}`,
        severity: 'error'
      });
    }
  };

  // Call this in useEffect
  useEffect(() => {
    fetchContactData();
    fetchActivities();
    fetchAttachments();
    fetchAccounts(); // Add this line
    fetchFeedItems(); // Add feed items fetch
  }, [id]);

  const fetchFeedItems = async () => {
    setIsFeedLoading(true);
    try {
      const response = await axiosInstance.get(`/feed-items/entity/contacts/${id}`);
      setFeedItems(response.data || []);
    } catch (error) {
      console.error('Error fetching feed items:', error);
      setFeedItems([]);
    } finally {
      setIsFeedLoading(false);
    }
  };

  const handleEchoSubmit = async (feedItem) => {
    // Add the new feed item to the beginning of the list
    setFeedItems(prevItems => [feedItem, ...prevItems]);
    
    // Close the modal
    handleCloseEchoModal();
    
    // Show success message
    setSnackbar({
      open: true,
      message: 'Message posted successfully!',
      severity: 'success',
    });
    
    // Refresh the feed items to ensure we have the latest data
    await fetchFeedItems();
  };

  const handleEditFeedItem = async (editData) => {
    try {
      setIsEditingFeed(true);
      
      // Extract the feed item ID from the edit data
      const feedItemId = editData.feed_item_id;
      
      if (!feedItemId) {
        throw new Error('No feed item ID found in edit data');
      }
      
      console.log('=== EDIT FEED ITEM DEBUG ===');
      console.log('Feed Item ID:', feedItemId);
      console.log('Edit Data received:', editData);
      console.log('Object Type:', editData.object_type);
      console.log('Object ID:', editData.object_id);
      console.log('Body content:', editData.body);
      console.log('Mentions:', editData.mentions);
      
      // Make the PUT request to the correct endpoint with the feed item ID
      const response = await axiosInstance.put(`/feed-items/${feedItemId}`, {
        feeditem: {
          object_type: editData.object_type,
          object_id: editData.object_id,
          body: editData.body
          // Don't include mentions - backend will parse them from body automatically
        }
      });
      
      if (response.status === 200) {
        // Refresh the entire feed to get updated data and proper sorting
        await fetchFeedItems();
        
        setSnackbar({
          open: true,
          message: 'Message updated successfully!',
          severity: 'success',
        });
        
        // The EchoComposer will handle clearing the edit state via onSuccess callback
        // so we don't need to do it here
      }
    } catch (error) {
      console.error('Error updating feed item:', error);
      setSnackbar({
        open: true,
        message: 'Error updating message',
        severity: 'error',
      });
    } finally {
      setIsEditingFeed(false);
    }
  };

  const handleDeleteFeedItem = async (feedItemId) => {
    try {
      const response = await axiosInstance.delete(`/feed-items/${feedItemId}`);
      
      if (response.status === 200) {
        // Update the feed items state by removing the deleted item
        setFeedItems(prevItems => prevItems.filter(item => item.id !== feedItemId));
        
        setSnackbar({
          open: true,
          message: 'Message deleted successfully!',
          severity: 'success',
        });
      }
    } catch (error) {
      console.error('Error deleting feed item:', error);
      setSnackbar({
        open: true,
        message: 'Error deleting message',
        severity: 'error',
      });
    }
  };

  const handleDeleteConfirm = (feedItem) => {
    setItemToDelete(feedItem);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setItemToDelete(null);
  };

  const handleDeleteConfirmOk = async () => {
    if (itemToDelete) {
      await handleDeleteFeedItem(itemToDelete.id);
      setDeleteConfirmOpen(false);
      setItemToDelete(null);
    }
  };

  const startEditFeedItem = (feedItem) => {
    setEditingFeedItem(feedItem.id);
    setEditFeedContent(feedItem.feeditem.body);
  };

  const cancelEditFeedItem = () => {
    setEditingFeedItem(null);
    setEditFeedContent('');
  };

  const handleOpenEchoModal = () => {
    setIsEchoModalOpen(true);
  };

  const handleCloseEchoModal = () => {
    setIsEchoModalOpen(false);
  };

  const handleCreateEcho = async () => {
    // This will be handled by EchoComposer's onSubmit
    handleCloseEchoModal();
  };

  // Component for rendering mentions with immediate name display
  const MentionDisplay = ({ mention, fullMatch, entityTypeOrUser, entityId, mentions, navigate }) => {
    // Calculate display name immediately without async operations
    let displayName = '';
    
    if (entityId) {
      // For entity mentions, we'll need to fetch the name
      // But for now, let's show the entity type and ID
      displayName = `${entityTypeOrUser}:${entityId}`;
    } else {
      // For user mentions, use entity_name immediately if available
      if (mention && mention.entity_name) {
        displayName = mention.entity_name;
      } else {
        // Fallback to username
        displayName = entityTypeOrUser;
      }
    }

    return (
      <Box
        component="span"
        sx={{
          color: entityId ? 'info.main' : 'primary.main',
          fontWeight: 'bold',
          backgroundColor: entityId ? 'rgba(33, 150, 243, 0.08)' : 'rgba(103, 58, 183, 0.08)',
          px: 0.5,
          py: 0.25,
          borderRadius: 0.5,
          mx: 0.25,
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: entityId ? 'rgba(33, 150, 243, 0.15)' : 'rgba(103, 58, 183, 0.15)',
          }
        }}
        onClick={() => {
          if (entityId) {
            // Navigate to the mentioned entity
            navigate(`/${entityTypeOrUser.toLowerCase()}s/${entityId}`);
          } else {
            // Handle user mention - navigate to user profile
            if (mention && mention.entity_id) {
              navigate(`/users/${mention.entity_id}/profile`);
            }
          }
        }}
      >
        {displayName}
      </Box>
    );
  };

  // Helper function to extract name parts from created_by_name
  const extractNameParts = (createdByUser, createdByName) => {
    let nameParts = {
      firstName: 'U',
      middleName: '',
      lastName: '',
      avatarUrl: null
    };

    if (createdByUser?.first_name && createdByUser?.last_name) {
      nameParts = {
        firstName: createdByUser.first_name,
        middleName: createdByUser.middle_name || '',
        lastName: createdByUser.last_name,
        avatarUrl: createdByUser.avatar || null
      };
    } else if (createdByName) {
      const namePartsArray = createdByName.split(' ').filter(part => part.trim());
      if (namePartsArray.length === 1) {
        nameParts = {
          firstName: namePartsArray[0],
          middleName: '',
          lastName: '',
          avatarUrl: null
        };
      } else if (namePartsArray.length >= 2) {
        nameParts = {
          firstName: namePartsArray[0],
          middleName: namePartsArray.slice(1, -1).join(' '),
          lastName: namePartsArray[namePartsArray.length - 1],
          avatarUrl: null
        };
      }
    }
    
    return nameParts;
  };

  // Enhanced feed content parser that uses async name fetching
  const parseFeedContent = (feedItem) => {
    if (!feedItem?.feeditem?.body) return '';
    
    const body = feedItem.feeditem.body;
    const mentions = feedItem.feeditem.mentions || [];
    
    console.log('Parsing feed content:', { body, mentions });
    
    // Parse mentions in the format @username (for users) or @EntityType:entityId (for entities)
    const parts = [];
    const mentionRegex = /@([A-Za-z0-9_.@]+)(?::([A-Za-z0-9_]+))?/g;
    let lastIndex = 0;
    let match;
    
    // Create a map of usernames to mention data for better matching
    const userMentionsMap = {};
    mentions.forEach(mention => {
      if (mention.type === 'user' && mention.entity_name) {
        // Try to match by username pattern in the body
        const usernamePattern = new RegExp(`@${mention.entity_name.replace(/\s+/g, '[._]')}`, 'i');
        if (usernamePattern.test(body)) {
          userMentionsMap[mention.entity_name] = mention;
        }
      }
    });
    
    while ((match = mentionRegex.exec(body)) !== null) {
      // Add text before mention
      if (match.index > lastIndex) {
        parts.push(
          <span key={`text-${lastIndex}`}>
            {body.substring(lastIndex, match.index)}
          </span>
        );
      }
      
      // Add mention as highlighted text with async name fetching
      const [fullMatch, firstPart, secondPart] = match;
      
      // Determine if this is a user mention or entity mention
      let entityTypeOrUser, entityId;
      
      if (secondPart) {
        // Format: @EntityType:entityId
        entityTypeOrUser = firstPart;
        entityId = secondPart;
      } else {
        // Format: @username (user mention)
        entityTypeOrUser = firstPart;
        entityId = null;
      }
      
      // Find the corresponding mention data
      let mentionData;
      if (entityId) {
        // For entity mentions: @EntityType:entityId
        mentionData = mentions.find(m => m.type === 'record' && m.entity_type === entityTypeOrUser && m.entity_id === entityId);
      } else {
        // For user mentions: @username - try multiple matching strategies
        // First, try exact match with entity_name
        mentionData = mentions.find(m => m.type === 'user' && m.entity_name === entityTypeOrUser);
        
        // If not found, try matching by username pattern
        if (!mentionData) {
          const userMention = mentions.find(m => {
            if (m.type === 'user' && m.entity_name) {
              // Check if the username in text matches the entity_name (with possible dots/underscores)
              const normalizedEntityName = m.entity_name.replace(/\s+/g, '[._]');
              const usernamePattern = new RegExp(`^${normalizedEntityName}$`, 'i');
              return usernamePattern.test(entityTypeOrUser);
            }
            return false;
          });
          if (userMention) {
            mentionData = userMention;
          }
        }
        
        // If still not found, try to find by position in the mentions array
        if (!mentionData) {
          const userMentions = mentions.filter(m => m.type === 'user');
          // Count how many user mentions we've seen so far in the text
          const textBeforeCursor = body.substring(0, match.index);
          const userMentionsBefore = (textBeforeCursor.match(/@[A-Za-z0-9_.@]+/g) || []).length;
          if (userMentionsBefore < userMentions.length) {
            mentionData = userMentions[userMentionsBefore];
          }
        }
      }
      
      parts.push(
        <MentionDisplay
          key={`mention-${match.index}`}
          mention={mentionData}
          fullMatch={fullMatch}
          entityTypeOrUser={entityTypeOrUser}
          entityId={entityId}
          mentions={mentions}
          navigate={navigate}
        />
      );
      
      lastIndex = match.index + fullMatch.length;
    }
    
    // Add remaining text
    if (lastIndex < body.length) {
      parts.push(
        <span key={`text-end`}>
          {body.substring(lastIndex)}
        </span>
      );
    }
    
    return parts;
  };

  const fetchContactData = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(`/contacts/${id}`);
      const contactData = response.data;

      // If the API returns custom fields in a separate object, merge them into the main data
      if (contactData.custom_fields) {
        Object.entries(contactData.custom_fields).forEach(([key, value]) => {
          contactData[key] = value;
        });
      }

      console.log('Processed contact data:', contactData);
      setContact(contactData);
    } catch (error) {
      console.error('Error initializing page:', error);
      if (error.response?.status === 403) {
        setIsUnauthorized(true);
        setSnackbar({
          open: true,
          message: "You don't have permission to access this Contact",
          severity: 'error',
        });
        // Optionally redirect after a delay
        setTimeout(() => {
          navigate('/contacts');
        }, 3000);
      } else {
        setSnackbar({
          open: true,
          message: 'Error loading Contact data. Please try again later.',
          severity: 'error',
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchActivities = async () => {
    console.log('fetchActivities function called');
    console.log('ID value:', id); // Log the `id` to ensure it has the correct value.

    try {
      const params = new URLSearchParams();

      // Log when parameters are being appended.
      if (true) {
        console.log('Appending "parent_table" to params with value "contacts"');
        params.append('parent_table', 'contacts');
      }
      if (true) {
        console.log(`Appending "parent_table_id" to params with value "${id}"`);
        params.append('parent_table_id', id);
      }

      console.log('URLSearchParams created:', params.toString());

      // Uncomment if using the commented axios call for testing.
      // console.log('Sending request to `/activities/` with params:', params.toString());

      // Sending request to endpoint
      console.log(`Sending GET request to /activities/contacts/${id}`);
      const response = await axiosInstance.get('/activities/', {
        params: {
          parent_table: 'contacts',
          parent_table_id: id
        }
      });
      // Log the response status and data
      console.log('Response status:', response.status);
      console.log('Response data:', response.data);

      // Ensure data is valid before setting
      setActivities(response.data || []);
      console.log('Activities state updated successfully');
    } catch (error) {
      // Log detailed error information
      console.error('Error occurred during fetchActivities execution:', {
        message: error.message,
        name: error.name,
        stack: error.stack,
        config: error.config,
        response: error.response,
      });

      // Check if response is defined and log its details
      if (error.response) {
        console.error('Error response details:', {
          status: error.response.status,
          statusText: error.response.statusText,
          data: error.response.data,
        });
      } else {
        console.error('No response received. Possible network error.');
      }

      // Show error notification
      setSnackbar({
        open: true,
        message: `Error fetching activities: ${error.message}`,
        severity: 'error',
      });

      // Clear activities state on error
      setActivities([]);
    }
  };


  useEffect(() => {
    fetchContactData();
    fetchActivities();
    fetchAttachments();
    fetchAccounts();
  }, [id]);

  const handleEditToggle = () => {
    // Check if the user is a support user
    if (isSupportUser) {
        setSnackbar({
            open: true,
            message: 'Support users are not allowed to edit contacts.',
            severity: 'error',
        });
        return; // Exit the function early
    }
    // setIsEditLoading(true);
    try {
        if (isEditing) {
            handleSaveChanges();
        }
        setIsEditing(!isEditing);
    } finally {
        // setIsEditLoading(false);
    }
  };

  useEffect(() => {
    const fetchCustomFields = async () => {
      try {
        const response = await axiosInstance.get(`/custom-fields/contacts`);
        setCustomFields(response.data || []);
      } catch (error) {
        console.error('Error fetching custom fields:', error);
        setCustomFields([]);
      }
    };

    fetchCustomFields();
  }, []);

  const renderCustomFields = () => {
    if (!customFields || customFields.length === 0) {
      return null;
    }
    return (
      <CustomFieldsSection
        ref={customFieldsRef}
        objectType="contacts"
        objectData={contact}
        isEditing={isEditing}
        onFieldUpdate={(field, value) => {
          handleFieldUpdate(field, value);
        }}
        onError={(field, error) => handleFieldError(field, error)}
        formErrors={formErrors}
      />
    );
  };



  const handleFieldUpdate = (field, value) => {
    setUpdatedFields((prev) => {
      let updatedValue = value;

      // Handle custom fields (fields starting with cf_)
      if (field.startsWith('cf_')) {
        // Handle empty values
        if (value === '' || value === undefined) {
          updatedValue = null;
        }
        // Handle number fields - allow 0 values
        else if (typeof value === 'string' && !isNaN(value)) {
          const numValue = parseFloat(value);
          updatedValue = Number.isFinite(numValue) ? Number(numValue.toFixed(2)) : value;
        }
        // Handle boolean values
        else if (value === true || value === false) {
          updatedValue = value;
        }
        // Handle string values
        else if (value === null || typeof value === 'string') {
          updatedValue = value;
        }
      }

      return { ...prev, [field]: updatedValue };
    });

    setFormErrors((prev) => {
      let next = prev;
      if (prev[field]) {
        const { [field]: _, ...rest } = prev;
        next = rest;
      }
      // Cross-field: once either email or phone has content, clear the
      // *pairing* error on the other field only — a genuine format error
      // (e.g. bad email) on the other field must survive.
      if ((field === 'email' || field === 'phone') && typeof value === 'string' && value.trim()) {
        const other = field === 'email' ? 'phone' : 'email';
        if (next[other] === CONTACT_EMAIL_PHONE_REQUIRED) {
          const { [other]: _, ...rest } = next;
        next = rest;
      }
      }
      return next;
    });
  };

  const handleFieldError = (field, error) => {
    if (error) {
      setFormErrors(prev => ({
        ...prev,
        [field]: error
      }));
    } else {
      setFormErrors(prev => {
        const { [field]: _, ...rest } = prev;
        return rest;
      });
    }
  };

  const contactTitleOptions = ["Mr.", "Mrs.", "Ms.", "Dr.", "Prof."];
  const contactStatusOptions = ["Active", "Inactive", "On Hold"];

  const validateContactForm = () => {
    const data = { ...contact, ...updatedFields };
    const errors = {};

    if (data.title && !contactTitleOptions.includes(data.title)) {
      errors.title = 'Please enter valid value for salutation';
    }

    if (!data.first_name) {
      errors.first_name = 'First name is required';
    } else {
      const firstNameErr = validatePersonOrEntityName(data.first_name, 'First name');
      if (firstNameErr) errors.first_name = firstNameErr;
    }

    if (data.middle_name) {
      const middleNameErr = validatePersonOrEntityName(data.middle_name, 'Middle name');
      if (middleNameErr) errors.middle_name = middleNameErr;
    }

    if (!data.last_name) {
      errors.last_name = 'Last name is required';
    } else {
      const lastNameErr = validatePersonOrEntityName(data.last_name, 'Last name');
      if (lastNameErr) errors.last_name = lastNameErr;
    }

    // Either email or phone is required, and whichever is filled must be
    // well-formed. (InlineEditField itself also validates Email/Phone
    // format internally on blur — this duplicates that so we can block
    // save and scroll to the field even if the person never blurred it.)
    const trimmedEmail = (data.email || '').trim();
    const trimmedPhone = (data.phone || '').trim();

    if (!trimmedEmail && !trimmedPhone) {
      errors.email = CONTACT_EMAIL_PHONE_REQUIRED;
      errors.phone = CONTACT_EMAIL_PHONE_REQUIRED;
    } else {
      if (trimmedEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
        errors.email = 'Please enter a valid email address';
      }
      if (trimmedPhone && !/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(trimmedPhone)) {
        errors.phone = 'Please enter a valid phone number';
      }
    }

    if (!data.account_id) {
      errors.account_id = 'Please select one account';
    }

    if (!data.contact_role) {
      errors.contact_role = 'Designation is required';
    }

    if (!data.contact_status) {
      errors.contact_status = 'Contact status is required';
    }

    if (data.contact_status && !contactStatusOptions.includes(data.contact_status)) {
      errors.contact_status = 'Please enter valid value for contact status';
    }

    return errors;
  };

  const handleActivitySaved = async (newActivityData) => {
    setIsActivitySaving(true); // Show loader only in activity modal
    try {
      const currentDate = new Date().toISOString();

      // Update activities state immediately with new activity
      setActivities(prevActivities => [...prevActivities, newActivityData]);

      // Update last activity date
      await axiosInstance.patch(`/contacts/${id}`, {
        last_activity: currentDate,
      });

      setSnackbar({
        open: true,
        message: 'Activity created successfully!',
        severity: 'success',
      });

      // Close the modal after successful creation
      handleCloseActivityModal();

    } catch (error) {
      console.error('Error updating last activity:', error);
      setSnackbar({
        open: true,
        message: 'Error updating last activity',
        severity: 'error',
      });
    } finally {
      setIsActivitySaving(false); // Hide activity loader
    }
  };

  const fieldOrder = [
    'first_name',
    'middle_name',
    'last_name',
    'email',
    'phone',
    'account_id',
    'contact_role',
    'contact_status',
  ];

  const scrollToFirstError = (errors) => {
    const firstErrorField = fieldOrder.find((field) => errors[field]);
    if (!firstErrorField) return;

    const el = document.getElementById(`field-${firstErrorField}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const focusable = el.querySelector('input, [role="button"], textarea');
      if (focusable && typeof focusable.focus === 'function') {
        setTimeout(() => focusable.focus({ preventScroll: true }), 300);
      }
    }
  };

  const handleSaveChanges = async () => {
    const validationErrors = validateContactForm();
    const isCustomFieldsValid = customFieldsRef.current?.validateAllFields() ?? true;
    const combinedErrors = { ...formErrors, ...validationErrors };

    if (Object.keys(validationErrors).length > 0 || !isCustomFieldsValid) {
      setFormErrors(prev => ({ ...prev, ...validationErrors }));
      const firstMessage = Object.values(validationErrors)[0] || 'Please correct the errors before saving.';
      setSnackbar({
        open: true,
        message: firstMessage,
        severity: 'error',
      });
      scrollToFirstError(combinedErrors);
      return;
    }

    setIsSaving(true); // Show loader on save button
    console.log('Saving changes:', updatedFields);

    if (Object.keys(updatedFields).length > 0) {
      try {
        const payload = {
          ...contact,
          ...updatedFields,
          custom_fields: {},
          updated_at: new Date().toISOString(),
        };

        Object.keys(payload).forEach(key => {
          if (key.startsWith('cf_')) {
            payload.custom_fields[key] = payload[key];
            delete payload[key];
          }
        });

        console.log('Formatted payload:', payload);

        const response = await axiosInstance.patch(`/contacts/${contact.id}`, payload);
        const refreshResponse = await axiosInstance.get(`/contacts/${contact.id}`);
        const contactData = refreshResponse.data;

        if (contactData.custom_fields) {
          Object.entries(contactData.custom_fields).forEach(([key, value]) => {
            contactData[key] = value;
          });
        }

        setContact(contactData);
        setUpdatedFields({});
        setFormErrors({});
        await frontendLogger.logUpdate('Contact', contact.id, {
          ...payload,
          user: user.username
        });
        setSnackbar({
          open: true,
          message: 'Contact updated successfully!',
          severity: 'success',
        });
      } catch (error) {
        console.error('Error updating contact:', error);
        setSnackbar({
          open: true,
          message: 'Error updating contact. Please try again.',
          severity: 'error',
        });
      } finally {
        setIsSaving(false); // Hide loader after save completes
      }
    }

    setIsEditing(false);
  };

  const handleOpenDeleteModal = () => setIsDeleteModalOpen(true);
  const handleCloseDeleteModal = () => setIsDeleteModalOpen(false);

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleDelete = async () => {
    // Check if the user is a support user
    if (isSupportUser) {
        setSnackbar({
            open: true,
            message: 'Support users are not allowed to delete contacts.',
            severity: 'error',
        });
        return; // Exit the function early
    }
    setIsDeletingContact(true); // Start delete button loader
    try {
      await axiosInstance.delete(`/contacts/${contact.id}`);
      await frontendLogger.logDelete('Contact', {
        id: contact.id,
        user: user.username
      });
      setSnackbar({
        open: true,
        message: 'Contact deleted successfully',
        severity: 'success',
      });
      // Short delay before navigation to show success message
      setTimeout(() => {
        navigate('/contacts/');
      }, 1500);
    } catch (error) {
      console.error('Error deleting contact:', error);
      setSnackbar({
        open: true,
        message: 'Error deleting contact',
        severity: 'error',
      });
      setIsDeletingContact(false); // Reset delete button loader on error
    }
  };

  const handleOpenActivityModal = () => {
    setIsActivityModalOpen(true);
  };

  const handleCloseActivityModal = () => {
    setIsActivityModalOpen(false);
    setNewActivity({
      contact_id: id,
      type: '',
      description: '',
      date: new Date().toISOString().split('T')[0],
    });
  };



  const handleUploadSuccess = async (uploadData) => {
    console.log('Upload successful:', uploadData);

    const uploadDataPayload = {
      file_name: uploadData.file.name,
      file_type: uploadData.file.type,
      file_size: uploadData.file.size,
      bucket_name: uploadData.bucket,
      storage_path: uploadData.path,
      description: uploadData.description || '', // Optional, use default if no description is provided
      parent_table: 'contacts',  // Assuming the parent table is 'leads', modify as needed
      parent_id: id,  // Assuming the parent ID is the same as lead ID
      is_active: true,
      is_private: uploadData.isPrivate || false, // Default to false if not provided
      file_url: uploadData.url,
      signed_url_expiry: uploadData.signedUrlExpiry || null,
    };

    setIsAttachmentModalOpen(false);
    try {
      const response = await axiosInstance.post(`/attachments/`, uploadDataPayload);

      setSnackbar({
        open: true,
        message: 'File uploaded successfully!',
        severity: 'success',
      });

      // Update files or attachments state as needed
      // setFiles([...files, response.data]); // Uncomment if `files` state exists
    } catch (error) {
      console.error('Error uploading file:', error);
      setSnackbar({
        open: true,
        message: 'Error uploading file',
        severity: 'error',
      });
    } finally {
      fetchAttachments();
    }
  };

  const handleCloneClick = () => {
    // Check if the user is a support user
    if (isSupportUser) {
        setSnackbar({
            open: true,
            message: 'Support users are not allowed to clone contacts.',
            severity: 'error',
        });
        return; // Exit the function early
    }
    if (!contact) {
      setSnackbar({
        open: true,
        message: 'Cannot clone contact: Contact data not loaded',
        severity: 'error'
      });
      return;
    }

    setIsCloneModalOpen(true);
  };

  const handleCloneSave = async (formDataToSave) => {
    if (isSupportUser) {
      setSnackbar({ open: true, message: 'Support users are not allowed to clone contacts.', severity: 'error' });
      throw new Error('Support users cannot clone contacts');
    }
    const payload = {
      ...formDataToSave,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
        last_activity: new Date().toISOString(),
      };
    try {
      setIsCloning(true);
      const response = await axiosInstance.post('/contacts/', payload);
      await frontendLogger.logCreate('Contact', {
        id: response.data.id,
        action: 'clone',
        cloned_from: contact.id,
        user: user.username,
        details: payload,
      });
      setSnackbar({ open: true, message: 'Contact cloned successfully!', severity: 'success' });
      setTimeout(() => navigate(`/contacts/${response.data.id}`), 1500);
    } catch (error) {
      console.error('Error cloning contact:', error);
      // Re-throw: ContactFormModal's own catch reads error.response.data.detail
      // and, if it mentions "email", surfaces it inline on the Email field.
      throw error;
    } finally {
      setIsCloning(false);
    }
  };

  const handleDeleteAttachment = async (attachmentId) => {
    try {
      await axiosInstance.delete(`/attachments/${attachmentId}`);
      setAttachments(attachments.filter((attachment) => attachment.id !== attachmentId));
      setSnackbar({
        open: true,
        message: 'Attachment deleted successfully!',
        severity: 'success',
      });
    } catch (error) {
      console.error('Error deleting attachment:', error);
      setSnackbar({
        open: true,
        message: 'Error deleting attachment',
        severity: 'error',
      });
    }
  };

  const handleDownloadAttachment = async (attachment) => {
    try {
      if (!attachment.bucket_name || !attachment.storage_path) {
        throw new Error('Attachment storage metadata is invalid for strict R2 download');
      }
      await downloadPrivateObject({
        axiosInstance,
        attachmentId: attachment.id,
        fileName: attachment.file_name
      });
    } catch (error) {
      console.error('Error downloading attachment:', error);
      setSnackbar({
        open: true,
        message: 'Error downloading attachment',
        severity: 'error',
      });
    }
  };
  const fetchAttachments = async () => {
    const parentTable = 'contacts';
    const parentId = id;
    try {
      const response = await axiosInstance.get('/attachments/', {
        params: {
          parent_table: parentTable,
          parent_id: parentId,
        },
      });
      setAttachments(response.data || []);
    } catch (error) {
      console.error('Error fetching attachments:', error);
      const errorMessage =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        'Error fetching attachments';
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error',
        autoHideDuration: 5000,
      });
    }
  };

  const handleDeleteActivity = async (activityId) => {
    setIsLoading(true);
    try {
      await axiosInstance.delete(`/activities/${activityId}`);
      setActivities(activities.filter((activity) => activity.id !== activityId));
      setSnackbar({
        open: true,
        message: 'Activity deleted successfully!',
        severity: 'success',
      });
      await frontendLogger.logDelete('Activity', {
        id: activityId,
        parent_table: 'contacts',
        parent_table_id: id,
        user: user.username
      });
    } catch (error) {
      console.error('Error deleting activity:', error);
      setSnackbar({
        open: true,
        message: 'Error deleting activity',
        severity: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditActivity = (updated) => {
    if (!updated?.id) return;
    setActivities((prev) =>
      prev.map((a) => (a.id === updated.id ? { ...a, ...updated } : a)),
    );
  };

  useEffect(() => {
    if (!isEditing) {
      fetchContactData();
      fetchActivities();
      fetchAttachments();
    }
  }, [isEditing]);

  const handleDiscardChanges = async () => {
    setIsDiscarding(true);
    try {
      // Reset the form without fetching data
      setIsEditing(false);
      setUpdatedFields({});
      setFormErrors({});

      // Only fetch contact data as it's the main data
      const response = await axiosInstance.get(`/contacts/${id}`);
      const contactData = response.data;

      if (contactData.custom_fields) {
        Object.entries(contactData.custom_fields).forEach(([key, value]) => {
          contactData[key] = value;
        });
      }

      setContact(contactData);
    } catch (error) {
      console.error('Error resetting form:', error);
      setSnackbar({
        open: true,
        message: 'Error discarding changes. Please try again.',
        severity: 'error',
      });
    } finally {
      setIsDiscarding(false);
    }
  };

  const fullName = `${capitalizeFirstLetter(contact?.first_name || '')} ${capitalizeFirstLetter(contact?.middle_name || '')} ${capitalizeFirstLetter(contact?.last_name || '')}`.trim();

  // Toggle functions for CC and BCC fields
  const toggleCc = () => setShowCc(!showCc);
  const toggleBcc = () => setShowBcc(!showBcc);

  // Function to handle Quill editor changes
  const handleQuillChange = (content) => {
    setNewEmail({ ...newEmail, content });
  };

  // Define Quill editor modules and formats
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ color: [] }, { background: [] }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const quillFormats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'color', 'background',
    'link', 'image',
  ];


  const handleToggleEmailModal = async () => {
    // Only validate and fetch data when opening the modal
    if (!isEmailModalOpen) {
      // Check if contact data is loaded
      if (!contact) {
        setSnackbar({
          open: true,
          message: 'Contact details not loaded. Please try again.',
          severity: 'error',
        });
        return;
      }

      // Find the account associated with this contact (still used below for
      // emailContext, even though the guard no longer depends on it).
      const associatedAccount = accounts.find(acc => acc.value === contact.account_id);

      // Check if the contact itself has an email — email is optional on a
      // contact, so this is what actually determines whether we can compose.
      if (!contact.email || contact.email.trim() === '') {
        setSnackbar({
          open: true,
          message: 'This contact has no email address. Please add one before sending an email.',
          severity: 'warning',
        });
        return;
      }

      try {
        // Prepare email data with account information
        const contactDisplayName =
          `${contact.first_name || ''} ${contact.last_name || ''}`.trim() ||
          contact.last_name ||
          'Contact';
        const emailSubject = `Regarding ${contactDisplayName} - Contact Information`;
        let emailContent = ``;

        emailContent += `<p>Please let us know if you need any additional information.</p>
          <p>Best regards,<br>${user?.name || 'Sales Team'}<br>${user?.email || ''}</p>`;

        // Set initial email data
        setNewEmail({
          to: contact.email, // Use the contact's own email address
          cc: '',
          bcc: '',
          subject: emailSubject,
          content: emailContent,
          from: user.email // Include the sender's email
        });

        // Set email context for AI generation
        setEmailContext({
          type: 'contact',
          data: associatedAccount?.fullData, // May be undefined if no account is linked — fine, this is just context
          contact: contact,
          activities: activities,
          sender: user
        });

        // Clear any existing attachments
        setEmailAttachments([]);

        // Finally, open the email modal
        setIsEmailModalOpen(true);
      } catch (error) {
        console.error('Error preparing email data:', error);
        setSnackbar({
          open: true,
          message: 'Error preparing email data. Please try again.',
          severity: 'error',
        });
      }
    } else {
      // Just close the modal if it's already open
      setIsEmailModalOpen(false);
    }
  };


  // Function to generate email content using AI
  const handleGenerateEmail = async () => {
    setIsGeneratingEmail(true);
    setEmailError('');

    try {
      // Implementation for AI email generation
      const context = emailContext;
      let generatedContent = '';
      let subject = '';

      if (context.type === 'contact') {
        const account = context.data || {};
        const contactFullName = `${context.contact?.first_name || ''} ${context.contact?.last_name || ''}`.trim();
        const displayName = account.name || contactFullName || 'Customer';
        subject = `Contact Update: ${displayName}`;
        generatedContent = `<p>Dear ${contactFullName || 'Customer'},</p>
        <p>I hope this email finds you well. I'm reaching out regarding your contact with us.</p>
        <p>We value our partnership with ${displayName} and wanted to provide you with an update on your contact status.</p>
        <p>Here's a summary of your recent activity:</p>
        <ul>
          <li>Open Deals: ${context.deals?.length || 0}</li>
          <li>Recent Orders: ${context.orders?.length || 0}</li>
          <li>Active Cases: ${context.cases?.length || 0}</li>
        </ul>
        <p>If you have any questions or require any assistance, please don't hesitate to reach out.</p>
        <p>Looking forward to our continued collaboration.</p>
        <p>Best regards,<br>${user?.name || 'Sales Team'}</p>`;
      }

      // Set the email content before sending
      const emailToSend = {
        ...newEmail,
        subject: subject || newEmail.subject,
        content: generatedContent || newEmail.content,
      };

      setNewEmail(emailToSend);

      // Call the API to send the email
      const response = await axiosInstance.post('/emails/send', {
        context: context
      });

      if (response.status === 200) {
        // Success handling
        console.success('Email sent successfully!');
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error generating or sending email:', error);

      if (error.response) {
        console.error('Error data:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
        setEmailError(`Server error: ${error.response.data.detail || error.message}`);
      } else if (error.request) {
        console.error('Error request:', error.request);
        setEmailError('No response received from server. Please try again.');
      } else {
        console.error('Error message:', error.message);
        setEmailError(`Error: ${error.message}`);
      }
    } finally {
      setIsGeneratingEmail(false);
    }
  };

  const formatTimeForPayload = (date) => {
    return date.toTimeString().split(' ')[0]; // Returns time in HH:MM:SS format
  };

  // Add this helper function near other utility functions
  const stripHtmlTags = (html) => {
    if (!html) return '';
    // First replace <br>, <p>, and other block elements with newlines
    const textWithNewlines = html
      .replace(/<\/(p|div|br|h[1-6])>/gi, '\n')
      .replace(/<br\/?>/gi, '\n');
    // Then remove all HTML tags and decode HTML entities
    const div = document.createElement('div');
    div.innerHTML = textWithNewlines;
    return div.textContent || div.innerText || '';
  };

  // Update the handleSendEmail function
  const handleSendEmail = async () => {
    setIsEmailSending(true); // Start loading
    try {
      if (!newEmail.to || !newEmail.subject || !newEmail.content) {
        const missingFields = [];
        if (!newEmail.to) missingFields.push('To');
        if (!newEmail.subject) missingFields.push('Subject');
        if (!newEmail.content) missingFields.push('Content');
        throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
      }

      const emailPayload = {
        to: newEmail.to,
        subject: newEmail.subject,
        content: newEmail.content,
        cc: newEmail.cc || '',
        bcc: newEmail.bcc || '',
        parent_table: 'contacts',
        parent_table_id: id
      };

      // Send email
      const emailResponse = await axiosInstance.post('/emails/send', emailPayload);

      // After email is sent successfully, create an activity
      const now = new Date();
      const isoDate = now.toISOString();
      const formattedTime = formatTimeForPayload(now);

      const activityPayload = {
        title: `Email: ${newEmail.subject}`,
        type: "Email",
        status: "Completed",
        description: newEmail.content,
        starttime: formattedTime,
        endtime: formattedTime,
        due_date: isoDate,
        parent_table: "contacts",
        parent_table_id: id,
        assigned_to: user.id,
        assigned_to_name: user.fullname,
        all_day: false,
        color: "#edc949"
      };

      // Create activity
      const activityResponse = await axiosInstance.post('/activities/', activityPayload);

      if (!activityResponse.data) {
        throw new Error('Failed to create activity record');
      }

      setSnackbar({
        open: true,
        message: 'Email sent and activity created successfully',
        severity: 'success',
      });

      setEmailAttachments([]);
      setIsEmailModalOpen(false);

      // Refresh activities list
      await fetchActivities();

    } catch (error) {
      console.error('Error sending email or creating activity:', error);
      let errorMessage = 'Error sending email';

      if (error.response) {
        const { status, data } = error.response;
        errorMessage = typeof data.detail === 'string'
          ? data.detail
          : Array.isArray(data.detail)
            ? data.detail[0]?.msg || 'Unknown error'
            : 'Server error';

        if (status === 404 && data.detail === 'Email settings not found') {
          errorMessage = 'Email settings not configured. Please set up your email provider in settings.';
        } else if (status === 400) {
          errorMessage = 'Invalid request. Please check your input.';
        } else if (status === 401) {
          errorMessage = 'Authentication failed. Please log in again.';
        }
      } else if (error.request) {
        errorMessage = 'Failed to connect to the server';
      } else {
        errorMessage = error.message || 'Unknown error occurred';
      }

      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error',
      });
    } finally {
      setIsEmailSending(false);
    }
  };

  // Fetch global preferences for section order/hidden
  useEffect(() => {
    const fetchGlobalPreferences = async () => {
      try {
        const res = await axiosInstance.get('/preferences/global');
        const prefs = res.data?.section_preferences?.contact;
        if (prefs) {
          if (prefs.order) setSectionOrder(prefs.order);
          if (prefs.hidden) setHiddenSections(prefs.hidden);
        } else {
          setSectionOrder([
            'Basic Information',
            'Account Information',
            'Address',
            'Custom Field Information',
            'Audit Information',
          ]);
          setHiddenSections([]);
        }
      } catch (e) {
        setSectionOrder([
          'Basic Information',
          'Account Information',
          'Address',
          'Custom Field Information',
          'Audit Information',
        ]);
        setHiddenSections([]);
      } finally {
        setLoadingSections(false);
      }
    };
    fetchGlobalPreferences();
    // eslint-disable-next-line
  }, []);

  const visibleSections = sectionOrder.filter(key => !hiddenSections.includes(key));

  const renderSection = (title, fields, renderContent = null) => {
    // One body for both UIs: v2 shows it in a DetailSection, legacy keeps its card.
    const sectionBody = (
      <>
      <Grid container spacing={3}>
        {fields.map((item) => {
          let displayValue = contact?.[item.field] ?? '';
          if (item.field === 'created_at' || item.field === 'updated_at') {
            displayValue = formatDate(displayValue, 'datetime');
          } else if (typeof displayValue === 'string' && item.field !== 'email') {
            displayValue = capitalizeFirstLetter(displayValue);
          }
          const errorFieldKey = item.field === 'account_name' ? 'account_id' : item.field;

          return (
            <Grid item xs={12} md={6} key={item.field} id={`field-${errorFieldKey}`}>
              {item.isCheckbox ? (
                <MDBox display="flex" alignItems="center">
                  <MDTypography variant="button" fontWeight="medium" mr={1} color="text">{item.label}</MDTypography>
                  <input
                    type="checkbox"
                    checked={(item.field in updatedFields) ? !!updatedFields[item.field] : !!displayValue}
                    onChange={(e) => handleFieldUpdate(item.field, e.target.checked)}
                    disabled={!isEditing || (item.readOnly ?? false)}
                    required={item?.is_required}
                  />
                </MDBox>
              ) : item.field === 'account_name' ? (
                isEditing ? (
                  <Autocomplete
                    options={accounts}
                    getOptionLabel={(option) => capitalizeFirstLetter(option.label || "")}
                    value={
                      accounts.find((acc) =>
                        acc.value === (updatedFields.account_id !== undefined ? updatedFields.account_id : contact?.account_id)
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      const newAccountId = newValue ? newValue.value : null;
                      const newAccountName = newValue ? capitalizeFirstLetter(newValue.label) : "";
                      handleFieldUpdate("account_id", newAccountId);
                      handleFieldUpdate("account_name", newAccountName);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Account"
                        variant="outlined"
                        fullWidth
                        error={!!formErrors.account_id}
                        helperText={
                          formErrors.account_id ||
                          (accounts.length === 0 ? "No accounts available" : "")
                        }
                      />
                    )}
                    sx={{
                      '& .MuiInputBase-root': {
                        height: '45px',
                      }
                    }}
                  />
                ) : (
                  <MDBox display="flex" alignItems="center">
                    <MDTypography variant="button" color="text" mr={1} fontWeight="medium">
                      {item.label}
                    </MDTypography>
                    {(updatedFields.account_name || contact?.account_name) ? (
                      <MDTypography
                        variant="button"
                        color="info"
                        fontWeight="medium"
                        onClick={() => navigate(`/accounts/${updatedFields.account_id || contact?.account_id}`)}
                        sx={{
                          cursor: 'pointer',
                        }}
                      >
                        {capitalizeFirstLetter(updatedFields.account_name || contact?.account_name)}
                      </MDTypography>
                    ) : (
                      <MDTypography variant="caption" color="text.secondary">
                       
                      </MDTypography>
                    )}
                  </MDBox>
                )
              ) : item.field === 'created_by_name' || item.field === 'updated_by_name' ? (
                <InlineEditField
                  label={item.label}
                  value={capitalizeFirstLetter(displayValue)}
                  options={item.options}
                  onSave={(newValue) => handleFieldUpdate(item.field, capitalizeFirstLetter(newValue))}
                  isEditing={isEditing}
                  readOnly={item.readOnly ?? false}
                  renderValue={(value) => (
                    <MDTypography
                      component="span"
                      onClick={() => {
                        const userId = item.field === 'created_by_name' ? contact?.created_by : contact?.updated_by;
                        if (userId) {
                          navigate(`/users/${userId}/profile`);
                        }
                      }}
                      variant="button"
                      color="info"
                      fontWeight="medium"
                      sx={{
                        cursor: 'pointer',
                      }}
                    >
                      {capitalizeFirstLetter(value)}
                    </MDTypography>
                  )}
                />
              ) : item.field === 'mailing_address' && isEditing ? (
                  <Box
                      sx={{
                        mt: 2.5, // lines the top edge up with City/State/Country (margin="normal")
                        '& .MuiOutlinedInput-root, & .MuiInputBase-root': {
                          minHeight: 59,
                          alignItems: 'center',
                        },
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '12px',
                        },
                      }}
                  >
                    <AddressAutocompleteInput
                        label={item.label}
                        placeholder="Enter mailing address"
                        value={updatedFields.mailing_address ?? contact?.mailing_address ?? ''}
                        onChange={(nextAddress) => handleFieldUpdate('mailing_address', nextAddress)}
                        error={Boolean(formErrors.mailing_address)}
                        errorMessage={formErrors.mailing_address}
                    />
                  </Box>
              ) : item.field === 'mailing_country' && isEditing ? (
                <CountrySelect
                  label={item.label}
                  value={updatedFields.mailing_country ?? contact?.mailing_country ?? ''}
                  margin="normal"
                  onChange={(nextCountry) => {
                    setUpdatedFields((prev) => ({
                      ...prev,
                      mailing_country: nextCountry || '',
                      mailing_state: '',
                      mailing_city: '',
                    }));
                  }}
                />
              ) : item.field === 'mailing_state' && isEditing ? (
                <StateSelect
                  label={item.label}
                  country={updatedFields.mailing_country ?? contact?.mailing_country ?? ''}
                  value={updatedFields.mailing_state ?? contact?.mailing_state ?? ''}
                  margin="normal"
                  onChange={(nextState) => {
                    setUpdatedFields((prev) => ({
                      ...prev,
                      mailing_state: nextState || '',
                      mailing_city: '',
                    }));
                  }}
                />
              ) : item.field === 'mailing_city' && isEditing ? (
                <CitySelect
                  label={item.label}
                  country={updatedFields.mailing_country ?? contact?.mailing_country ?? ''}
                  state={updatedFields.mailing_state ?? contact?.mailing_state ?? ''}
                  value={updatedFields.mailing_city ?? contact?.mailing_city ?? ''}
                  margin="normal"
                  onChange={(nextCity) => handleFieldUpdate('mailing_city', nextCity || '')}
                />
              ) : (
                <InlineEditField
                  label={item.label}
                  value={item.field === 'email' ? displayValue : capitalizeFirstLetter(displayValue)}
                  options={
                    item.field === 'manager_id'
                      ? agents.map((agent) => ({ 
                          value: agent.id, 
                          label: capitalizeFirstLetter(agent.username) 
                        }))
                      : item.options 
                        ? item.options.map(opt => capitalizeFirstLetter(opt)) 
                        : null
                  }
                  onSave={(newValue) => handleFieldUpdate(item.field, item.field === 'email' ? newValue : (typeof newValue === 'string' ? capitalizeFirstLetter(newValue) : newValue))}
                  isEditing={isEditing}
                  readOnly={item.readOnly ?? false}
                  required={item?.is_required}
                  error={formErrors[errorFieldKey]}
                  multiline={item.multiline ?? false}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
      {renderContent && (
        <MDBox mt={3}>
          {renderContent}
        </MDBox>
      )}
      </>
    );
    return (
      <UiDetailSection
        title={title}
        legacy={
          <MDBox
            mb={3}
            p={3}
            borderRadius="lg"
            sx={{
              backgroundColor: 'white',
              boxShadow: 3,
            }}
          >
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <MDTypography variant="h6" fontWeight="medium" color="dark">
                {title}
              </MDTypography>
            </MDBox>
            {sectionBody}
          </MDBox>
        }
      >
        {sectionBody}
      </UiDetailSection>
    );
  };

  if (isLoading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <DataLoadingSpinner
          entityType="contact"
          title="Loading Contact Data"
          message="Please wait while we fetch the contact information..."
        />
        
      </DashboardLayout>
    );
  }

    // Check if the user has permission to access this lead
    if (isUnauthorized) {
      return (
        <DashboardLayout>
          <DashboardNavbar />
          <UnauthorizedAccess />
          
        </DashboardLayout>
      );
    }

  // Shared by the classic and v2 layouts below: the same actions, field
  // sections and side column render in both.
  const recordActions = (
    <>
      {!isEditing && (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {/* Renders nothing when telephony is not configured,
              so this is safe on every tenant. */}
          <CallButton
            phone={contact?.mobile_number || contact?.phone}
            parentTable="contacts"
            parentId={contact?.id}
            contactId={contact?.id}
            accountId={contact?.account_id}
            variant="icon"
            tone="header"
          />
          <Tooltip title="Send Email" placement="top">
            <IconButton
              onClick={handleToggleEmailModal}
              sx={commonIconButtonStyles}
            >
              <Email sx={{ color: '#ffffff', fontSize: 20 }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Edit Contact" placement="top">
            <IconButton
              aria-label="edit"
              onClick={handleEditToggle}
              sx={commonIconButtonStyles}
            >
              <Edit sx={{ color: '#ffffff', fontSize: 20 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Clone Contact" placement="top">
            <IconButton
              aria-label="clone"
              onClick={handleCloneClick}
              sx={commonIconButtonStyles}
            >
              <FileCopy sx={{ color: '#ffffff', fontSize: 20 }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Contact" placement="top">
            <IconButton
              aria-label="delete"
              onClick={handleOpenDeleteModal}
              sx={commonIconButtonStyles}
            >
              <Delete sx={{ color: '#ffffff', fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        </Box>
      )}
      {isEditing && (
        <Box sx={{ display: 'flex', gap: 2 }}>
          <MDButton
            variant="contained"
            onClick={handleDiscardChanges}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              color: '#ffffff',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
            startIcon={isDiscarding ? <CircularProgress size={20} color="inherit" /> : <Close />}
            disabled={isSaving || isDiscarding}
          >
            {isDiscarding ? 'Discarding...' : 'Discard'}
          </MDButton>
          <MDButton
            variant="contained"
            onClick={handleSaveChanges}
            sx={{
              background: 'linear-gradient(145deg, #2c2c2c, #1a1a1a)',
              color: '#ffffff',
              '&:hover': {
                background: 'linear-gradient(145deg, #1a1a1a, #2c2c2c)',
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
            startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : <Save />}
            disabled={isSaving}
          >
            {isSaving ? 'Saving...' : 'Save'}
          </MDButton>
        </Box>
      )}
      <ContactFormModal
        isOpen={isCloneModalOpen}
        onClose={() => setIsCloneModalOpen(false)}
        onSave={handleCloneSave}
        managers={agents}
        user={user}
        title="Clone Contact"
        // Clones start as Inactive: "New" isn't a valid contact status option.
        // Email/phone/mobile are unique across leads/contacts/accounts — leave
        // them blank so the user must enter new values (matches Lead clone).
        initialData={
          contact
            ? {
                ...contact,
                contact_status: 'Inactive',
                email: '',
                phone: '',
                mobile_number: '',
              }
            : null
        }
      />
    </>
  );
  const recordDetailsBody = (
    <>
      {!isLoading ? (
        <>
          {visibleSections.map(sectionLabel => {
            if (sectionLabel === 'Basic Information') {
              return renderSection('Basic Information', [
                { label: "Salutation", field: "title", options: ["Mr.", "Mrs.", "Ms.", "Dr.", "Prof."] },
                { label: "First Name", field: "first_name", is_required: true},
                { label: "Middle Name", field: "middle_name" },
                { label: "Last Name", field: "last_name", is_required: true },
                { label: "Email", field: "email" },
                { label: "Phone", field: "phone" },
                { label: "Mobile", field: "mobile_number" },
                { label: "Department", field: "department" },
                { label: "Notes", field: "notes", value: contact?.notes ?? '', onSave: (newValue) => handleFieldUpdate('notes', newValue), isEditing: isEditing, multiline: true },
              ]);
            }
            if (sectionLabel === 'Account Information') {
              return renderSection('Account Information', [
                { label: "Account:", field: "account_name", renderCustom: isEditing ? (
                  <Autocomplete
                    required
                    options={accounts}
                    getOptionLabel={(option) => capitalizeFirstLetter(option.label || "")}
                    value={
                      accounts.find((acc) =>
                        acc.value === (updatedFields.account_id ?? contact?.account_id)
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      const newAccountId = newValue ? newValue.value : null;
                      const newAccountName = newValue ? capitalizeFirstLetter(newValue.label) : "";
                      handleFieldUpdate("account_id", newAccountId);
                      handleFieldUpdate("account_name", newAccountName);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Account"
                        variant="outlined"
                        fullWidth
                        required
                        error={!!formErrors.account_id}
                        helperText={formErrors.account_id || (accounts.length === 0 ? "No accounts available" : "")}
                      />
                    )}
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "45px",
                      },
                    }}
                  />
                ) : undefined, readOnly: !isEditing },
                { label: "Primary Contact", field: "primary_contact", readOnly: false, isCheckbox: true },
                { label: "Contact Status", field: "contact_status", is_required: true, options: contactStatusOptions },
                { label: "Designation", is_required: true, field: "contact_role" },
              ]);
            }
            if (sectionLabel === 'Address') {
              return renderSection('Address', [
                { label: "Mailing Address", field: "mailing_address" },
                { label: "City", field: "mailing_city" },
                { label: "State", field: "mailing_state" },
                { label: "Country", field: "mailing_country" },
                { label: "Postal Code", field: "mailing_postal_code" },
              ]);
            }
            if (sectionLabel === 'Custom Field Information') {
              return renderSection('Custom Field Information', [], renderCustomFields());
            }
            if (sectionLabel === 'Audit Information') {
              return renderSection('Audit Information', [
                { label: "Created By", field: "created_by_name", readOnly: true },
                { label: "Modified By", field: "updated_by_name", readOnly: true },
                { label: "Created Date", field: "created_at", readOnly: true },
                { label: "Modified Date", field: "updated_at", readOnly: true },
              ]);
            }
            return null;
          })}
        </>
      ) : (
        <MDBox display="flex" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}
    </>
  );
  // Side-column pieces, named so the v2 record layout can place them in its
  // tabs and side column; recordSideColumn below keeps the classic order.
  const contactActivitiesCard = (
    <>
      <Card >
        <MDBox
          mx={2}
          mt={-3}
          py={2}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <EventIcon sx={{ color: 'white !important', mr: 1 }} />
            <MDTypography variant="h6" color="white">
              Activities
            </MDTypography>
          </Box>
          <MDButton variant="gradient" color="dark" onClick={handleOpenActivityModal}>
            Add Activity
          </MDButton>
        </MDBox>
        <MDBox p={2}>
          <Activities
            activities={activities.filter(Boolean)}
            onDelete={handleDeleteActivity}
            onEdit={handleEditActivity}
          />
        </MDBox>
      </Card>
    </>
  );

  // Attachments.
  const contactAttachmentsCard = (
    <>
      <Card style={{ marginTop: '10px' }}>
        <MDBox
          mx={2}
          mt={-3}
          py={2}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <AttachmentIcon sx={{ color: 'white !important', mr: 1 }} />
            <MDTypography variant="h6" color="white">
              Attachments
            </MDTypography>
          </Box>
          <MDButton variant="gradient" color="dark" onClick={() => setIsAttachmentModalOpen(true)}>
            Add Attachment
          </MDButton>
        </MDBox>
        <MDBox p={2}>
          <Attachments
            attachments={attachments}
            onDelete={handleDeleteAttachment}
            onDownload={handleDownloadAttachment}
          />
        </MDBox>
      </Card>
    </>
  );

  // Call recordings and transcripts.
  const contactCallHistoryCard = (
    <>
      {/* Recordings and transcripts for this record. Gates itself on the
          CALL_CENTER entitlement, so no check is needed here. */}
      <CallHistoryCard recordType="contact" recordId={id} />
    </>
  );

  // Echo feed.
  const contactEchoFeedCard = (
    <>
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <RecordVoiceOverIcon sx={{ color: 'white !important', mr: 1 }} />
            <MDTypography variant="h6" color="white">
              Echo Feed
            </MDTypography>
          </Box>
          <MDButton
            variant="gradient" color="dark"
            onClick={handleOpenEchoModal}
          >
            Add Message
          </MDButton>
        </MDBox>

        <MDBox p={2}>
          {/* EchoComposer removed, replaced by modal */}
          <Modal
            open={isEchoModalOpen}
            onClose={handleCloseEchoModal}
            aria-labelledby="echo-modal-title"
            aria-describedby="echo-modal-description"
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 600,
              bgcolor: 'background.paper',
              boxShadow: 24,
              borderRadius: 2,
              p: 4,
              display: 'flex',
              flexDirection: 'column',
            }}>
              <MDTypography id="echo-modal-title" variant="h6" mb={2}>
                Post a Feed
              </MDTypography>
              <EchoComposer
                onSubmit={handleEchoSubmit}
                onCancel={handleCloseEchoModal}
                placeholder="Type @ to mention users..."
                axiosInstance={axiosInstance}
                objectType="contacts"
                objectId={id}
                onSuccess={(message) => {
                  setSnackbar({
                    open: true,
                    message: 'Feed item created successfully',
                    severity: 'success',
                  });
                  handleCloseEchoModal();
                }}
                onError={(message) => setSnackbar({
                  open: true,
                  message: `Error creating feed item: ${message}`,
                  severity: 'error',
                })}
              />
            </Box>
          </Modal>
          {/* Display feed items */}
          <Box mt={3}>
            {isFeedLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                <CircularProgress size={24} color="info" />
              </Box>
            ) : feedItems.length > 0 ? (
              <Box className="pearl-echo-feed" sx={{ 
                maxHeight: 400, 
                overflowY: 'auto',
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                backgroundColor: '#fafafa'
              }}>
                {feedItems.map((item, index) => (
                  <Box 
                    key={item.id} 
                    sx={{ 
                      p: 2, 
                      borderBottom: index < feedItems.length - 1 ? '1px solid #e0e0e0' : 'none',
                      backgroundColor: 'white',
                      '&:hover': {
                        backgroundColor: '#f8f9fa'
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                      <MDUserAvatar
                        firstName={extractNameParts(item.created_by_user, item.created_by_name).firstName}
                        middleName={extractNameParts(item.created_by_user, item.created_by_name).middleName}
                        lastName={extractNameParts(item.created_by_user, item.created_by_name).lastName}
                        avatarUrl={extractNameParts(item.created_by_user, item.created_by_name).avatarUrl}
                        size={36}
                        variant="circular"
                        sx={{ mr: 2, flexShrink: 0 }}
                      />
                      <Box sx={{ flex: 1, minWidth: 0, ml:2  }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography 
                              variant="subtitle2" 
                              fontWeight="medium"
                              sx={{ 
                                color: 'primary.main',
                                cursor: 'pointer',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}
                              onClick={() => {
                                // Navigate to user profile
                                const userMention = item.feeditem.mentions?.find(m => m.type === 'user' && m.entity_name === item.created_by_name);
                                if (userMention) {
                                  navigate(`/users/${userMention.entity_id}/profile`);
                                }
                              }}
                            >
                              {item.created_by_name}
                            </Typography>
                            <Typography 
                              variant="caption" 
                              color="text.secondary" 
                              sx={{ ml: 1 }}
                            >
                              {formatDate(item.updated_at, 'datetime')}
                            </Typography>
                          </Box>

                          {/* Edit/Delete buttons - only show for current user's messages */}
                          {item.created_by === user?.id && (
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                              <Tooltip title="Edit message" arrow>
                                <MDButton
                                  size="small"
                                  variant="text"
                                  color="info"
                                  onClick={() => startEditFeedItem(item)}
                                  disabled={isEditingFeed}
                                  sx={{ minWidth: 'auto', p: 0.5 }}
                                >
                                  <Edit fontSize="small" />
                                </MDButton>
                              </Tooltip>
                              <Tooltip title="Delete message" arrow>
                                <MDButton
                                  size="small"
                                  variant="text"
                                  color="error"
                                  onClick={() => handleDeleteConfirm(item)}
                                  disabled={isEditingFeed}
                                  sx={{ minWidth: 'auto', p: 0.5 }}
                                >
                                  <Delete fontSize="small" />
                                </MDButton>
                              </Tooltip>
                            </Box>
                          )}
                        </Box>

                        {editingFeedItem === item.id ? (
                          <Box sx={{ mt: 1 }}>
                            <EchoComposer
                              value={editFeedContent}
                              onChange={setEditFeedContent}
                              placeholder="Edit your message..."
                              axiosInstance={axiosInstance}
                              objectType="contacts"
                              objectId={id}
                              feedItemId={item.id}
                              isEditMode={true}
                              onSubmit={handleEditFeedItem}
                              onCancel={cancelEditFeedItem}
                              onSuccess={() => {
                                // Auto-save when user clicks the Update button in EchoComposer
                                setEditingFeedItem(null);
                                setEditFeedContent('');
                              }}
                              sx={{ 
                                mb: 1,
                                '& .MuiInputBase-root': {
                                  backgroundColor: 'white'
                                }
                              }}
                            />
                          </Box>
                        ) : (
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              whiteSpace: 'pre-wrap',
                              lineHeight: 1.5,
                              color: 'text.primary'
                            }}
                          >
                            {parseFeedContent(item)}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>
                ))}
              </Box>
            ) : (
              <Box sx={{ 
                display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: -2,
              }}>
                  <Box sx={{
                    width: 50,
                    height: 50,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'rgba(0,0,0,0.04)',
                    mb: 1.5 }}>
                    <RecordVoiceOverIcon sx={{ color: 'text.secondary', fontSize: 24,}} />
                  </Box>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  No messages yet
                </Typography>
              </Box>
            )}
          </Box>
        </MDBox>
      </Card>
    </>
  );

  // Upload dialog for Attachments.
  const contactAttachmentUploadModal = (
    <>
      <AttachmentUploadModal
        isOpen={isAttachmentModalOpen}
        onClose={() => setIsAttachmentModalOpen(false)}
        onUpload={handleUploadSuccess}
        axiosInstance={axiosInstance}
        allowedFileTypes="*/*"
        maxSizeInMB={5}
      />
    </>
  );

  const recordSideColumn = (
    <>
      {contactActivitiesCard}
      <Box mt={5} />
      {contactAttachmentsCard}
      <Box mt={5} />
      {contactCallHistoryCard}
      <Box mt={5} />
      {contactEchoFeedCard}
      {contactAttachmentUploadModal}
    </>
  );

  // v2: the contact laid out like Account 360 (components/v2/record). The
  // pieces are the ones the classic page renders.
  const openContactActivities = activities.filter((a) => a && !/complet|done|cancel/i.test(a.status || '')).length;
  const lastContactActivity = activities.map((a) => a?.created_at).filter(Boolean).sort().pop();
  const contactPlace = [contact?.mailing_city, contact?.mailing_state, contact?.mailing_country].filter(Boolean).join(', ');
  const contactPhone = contact?.mobile_number || contact?.phone;
  const v2Main = (
    <MDBox>
      <RecordPageV2
        sectionsLabel="Contact sections"
        hero={{
          label: 'Contact summary',
          icon: UserRound,
          eyebrow: contact?.primary_contact ? 'Primary contact' : 'Contact',
          title: fullName || '',
          animate: isCloning,
          actions: recordActions,
          badges: (
            <>
              {contact?.contact_status && <StatusBadge status={contact.contact_status} />}
              {contact?.contact_role && <HeroBadge>{contact.contact_role}</HeroBadge>}
            </>
          ),
          meta: [
            {
              key: 'account',
              icon: Building2,
              content: contact?.account_name && contact?.account_id ? (
                <Link to={`/accounts/${contact.account_id}`} style={{ color: 'inherit', fontWeight: 600 }}>{contact.account_name}</Link>
              ) : contact?.account_name,
            },
            { key: 'department', icon: Briefcase, content: contact?.department || null },
            { key: 'place', icon: MapPin, content: contactPlace || null },
            { key: 'email', icon: Mail, content: contact?.email ? linkedValue('Email', String(contact.email), contact.email, { showIcon: false }) : null },
            { key: 'phone', icon: Phone, content: contactPhone ? linkedValue('Phone', String(contactPhone), contactPhone, { showIcon: false }) : null },
          ],
        }}
        tiles={[
          { key: 'account', icon: Building2, label: 'Account', value: contact?.account_name || '—' },
          { key: 'open', icon: CheckSquare, label: 'Open activities', value: String(openContactActivities), tab: 'activity' },
          { key: 'last', icon: Clock, label: 'Last activity', value: relativeTime(lastContactActivity) || 'None yet', tab: 'activity' },
          { key: 'files', icon: Paperclip, label: 'Files', value: String(attachments.length), tab: 'files' },
          { key: 'created', icon: CalendarDays, label: 'Created', value: contact?.created_at ? formatDate(contact.created_at, 'date') : '—' },
        ]}
        tabs={[
          {
            key: 'overview',
            label: 'Overview',
            icon: LayoutGrid,
            render: () => (
              // Each field section is its own card (DetailSection), so no wrapping Card.
              <MDBox sx={{ animation: isCloning ? 'cloneAnimation 1s ease' : 'none' }}>
                {recordDetailsBody}
              </MDBox>
            ),
          },
          {
            key: 'activity',
            label: 'Activity',
            icon: History,
            count: activities.filter(Boolean).length,
            render: () => (
              <TabStack>
                {contactActivitiesCard}
                {contactEchoFeedCard}
                {contactCallHistoryCard}
              </TabStack>
            ),
          },
          { key: 'files', label: 'Files', icon: Paperclip, count: attachments.length, render: () => contactAttachmentsCard },
        ]}
        aside={(selectTab) => (
          <ActivityTimeline activities={activities} feedItems={feedItems} onOpenAll={() => selectTab('activity')} emptyText="No activity with this contact yet." />
        )}
      />
      {contactAttachmentUploadModal}
    </MDBox>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isV2 ? <RecordCallProvider value={{ parentTable: "contacts", parentId: contact?.id, contactId: contact?.id, accountId: contact?.account_id }}>{v2Main}</RecordCallProvider> : (
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Card
              sx={{
                animation: isCloning ? 'cloneAnimation 1s ease' : 'none',
              }}
            >
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <MDTypography
                    variant="h6"
                    color="white"
                    sx={{
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      overflowWrap: 'anywhere',
                      lineHeight: 1.35,
                      pr: 2,
                    }}
                  >
                    {fullName}
                  </MDTypography>
                  <MDBox>
                    {recordActions}
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox p={3}>
                {recordDetailsBody}
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            {recordSideColumn}
          </Grid>
        </Grid>
      </MDBox>
      )}

      <ActivityModal
        isOpen={isActivityModalOpen}
        onClose={handleCloseActivityModal}
        parentId={id}
        parent="contacts"
        axiosInstance={axiosInstance}
        onActivitySaved={handleActivitySaved}
        currentUser={user}
        isLoading={isActivitySaving}
      />

      <Modal
        open={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-modal-title"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
          <Box className="pearl-popup-header"
            sx={{
              backgroundColor: colors.popupHeader.background,
              px: 4,
              py: 3,
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            <MDTypography
              id="delete-modal-title"
              variant="h6"
              component="h2"
              sx={{ color: '#FFFFFF' }}
            >
              Delete Contact
            </MDTypography>
          </Box>
          <Box sx={{ p: 4 }}>
            <MDTypography variant="body1" mb={3}>
              Are you sure you want to delete this contact? This action cannot be undone.
            </MDTypography>
            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                onClick={handleCloseDeleteModal}
                variant="outlined"
                color="secondary"
                sx={{ marginRight: 2 }}
                disabled={isDeletingContact}
              >
                Cancel
              </MDButton>
              <MDButton
                onClick={handleDelete}
                variant="gradient"
                color="error"
                disabled={isDeletingContact}
              >
                {isDeletingContact ? (
                  <CircularProgress size={20} color="inherit" sx={{ mx: 1 }} />
                ) : (
                  'Delete'
                )}
              </MDButton>
            </MDBox>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      
      {/* Email Modal */}
      <EmailModal
        open={isEmailModalOpen}
        onClose={() => setIsEmailModalOpen(false)}
        newEmail={newEmail}
        setNewEmail={setNewEmail}
        handleSend={handleSendEmail}
        isGenerating={isGeneratingEmail}
        isSending={isEmailSending}
        errorMessage={emailError}
        emailContext={emailContext}
        setEmailContext={setEmailContext}
        handleGenerateEmail={handleGenerateEmail}
        showCc={showCc}
        showBcc={showBcc}
        toggleCc={toggleCc}
        toggleBcc={toggleBcc}
        handleQuillChange={handleQuillChange}
        modules={quillModules}
        formats={quillFormats}
        attachments={emailAttachments}
        setEmailAttachments={setEmailAttachments}
      />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-confirm-dialog-title"
        aria-describedby="delete-confirm-dialog-description"
      >
        <DialogTitle id="delete-confirm-dialog-title">
          Delete Message
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete this message? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleDeleteCancel} color="secondary">
            Cancel
          </MDButton>
          <MDButton onClick={handleDeleteConfirmOk} color="error" variant="contained">
            Delete
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default ContactDetail;